var script,
    timeout;

function detect() {
    return new Promise(function(resolve) {

        function detected() {
            resolve(true);
        }

        window.mailruEnabled = function () {
            resolve(false);
        };

        script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "//ad.mail.ru/adq/?callback=mailruEnabled&" + Date.now();
        script.onerror = detected;
        document.head.appendChild(script);

        timeout = setTimeout(detected, 4000);
    })
    .then(function(detected) {
        document.head.removeChild(script);
        window.mailruEnabled = null;
        script = null;
        clearTimeout(timeout);
        return detected;
    });
}

export default detect;
